<template>
  <div class="page-content">
    <page-template ref="salesTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import date from '@/mixin/date'

  export default {
    mixins: [date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '',
              prop: 'otherName',
              type: 'input',
              ifFuzzy: true,
              placeholder: "请输入业务单号"
            }
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: "单号",
              type: "input",
              prop: "orderNo",
              span: 12,
              placeholder: "业务单号"
            },
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              isHasAll: true,
              span: 12,
              change: this.getBrandSupplierChange,
              defaultValue: this.$utils.getSysUser().storeId,
              url: api.system.seStore,
            },
            {
              label: "供应商",
              type: "select",
              prop: "supplierId",
              data: [],
              // url: api.archives.supplier,
              param: {type: 10},
              span: 12,
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              type: 'select',
              defaultValue: 20,
              span: 12,
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '打印',
            code: 'print',
            filter: () => {
              return false
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              // showDetail: true
              callback: this.goOrderDetail
            },
            {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
            // {label: '供应商编码', prop: 'supplierCode', width: '150', align: 'center'},
            {label: '供应商名称', prop: 'supplierName', width: '190', align: 'center'},
            {label: '单据金额', prop: 'billAmount', width: '120', align: 'center'},
            {
              label: '状态',
              prop: 'reviewerStatus',
              width: '120',
              align: 'center',
              enumData: this.$utils.getCacheStatus('wlWholesaleOrder.reviewerStatus')
            },
            {label: '制单人', prop: 'voucherName', width: '120', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center',},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center',},
            {label: '备注', prop: 'remarks', width: '120', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate(),},
          url: api.settle.supplierSettlement
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '200px',
            top: '30px',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: '供应商',
              prop: 'supplierName',
            },
            {
              label: '门店',
              prop: 'storeName',
            },

            {
              label: '开户银行',
              prop: 'bankName',
            },
            {
              label: '银行账号',
              prop: 'bankAccount',
            },
            {
              label: '付款金额',
              prop: 'billAmount',
            },

            // {
            //   label: '开始日期',
            //   prop: 'startDttm',
            // },
            // {
            //   label: '结束日期',
            //   prop: 'endDttm',
            // },
            {
              label: '备注',
              prop: 'remarks',
            },
            // {
            //   label: '销售数量',
            //   prop: 'saleNum',
            // },
            // {
            //   label: '销售额',
            //   prop: 'salesVolume',
            // },
            // {
            //   label: '销售成本',
            //   prop: 'salesCost',
            // },
          ],
          tablesProp: {
            stSupplierSettlementMapList: {
              url: api.settle.SupplierSettlementMap + "/page",
              indexShow: true,
              height: this.detailHeight,
              showSummary: true,
              tableName: "stSupplierSettlementMapList",
              summaryColumns: ['payAmount', 'amountPaid', 'discountedAmount', 'outstandAmount', 'actualPayAmount', 'discountMoney'],
              columns: [
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '220',
                  align: "center"
                },
                {
                  label: "单据类型",
                  prop: "purchaseType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: "对账单号",
                  prop: "billOrderNo",
                  width: '220',
                  align: "center",
                },
                {
                  label: '应付金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已付金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '100',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未付金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实付金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  min: -Infinity,
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '200',
                  align: "center"
                },
              ]
            },
          },

          // 打印的列表
          printTablesProp: {
            stSupplierSettlementMapList: {
              tableName: 'stSupplierSettlementMapList',
              showSummary: true,
              summaryColumns: ['payAmount'],
              columns: [
                {
                  label: '序号',
                  prop: 'indexShow',
                  width: '50',
                  align: "center"
                },
                {
                  label: '单据号',
                  prop: 'purchaseOrderNo',
                  width: '220',
                  align: "center"
                },
                {
                  label: "单据类型",
                  prop: "purchaseType",
                  width: '120',
                  align: "center",
                  enumData: this.$utils.getCacheStatus('stSupplierSettlementMap.purchaseType')
                },
                {
                  label: "单据日期",
                  prop: "billDttm",
                  width: '180',
                  align: "center"
                },
                {
                  label: "对账单号",
                  prop: "billOrderNo",
                  width: '220',
                  align: "center",
                },
                {
                  label: '应付金额',
                  width: '90',
                  prop: 'payAmount',
                  align: "center",
                },
                {
                  label: '已付金额',
                  width: '125',
                  prop: 'amountPaid',
                  align: "center"
                },
                {
                  label: '已优惠金额',
                  width: '100',
                  prop: 'discountedAmount',
                  align: "center"
                },
                {
                  label: '未付金额',
                  width: '90',
                  prop: 'outstandAmount',
                  align: "center"
                },
                {
                  label: '实付金额',
                  width: '90',
                  prop: 'actualPayAmount',
                  align: "center",
                  min: -Infinity,
                  precision: 2
                },
                {
                  label: '优惠金额',
                  width: '90',
                  prop: 'discountMoney',
                  align: "center",
                  precision: 2
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '200',
                  align: "center"
                },
              ]
            },
          },
          url: api.settle.supplierSettlement
        }
      };
    },
    beforeCreate() {
      this.detailHeight = document.documentElement.clientHeight - 180 - 300
    },
    created() {
      this.storeDefault()
      this.$nextTick(() => {
        this.$refs['salesTemplate'].operationSuccess();
      })
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      // this.$nextTick(() => {
      //   this.tableOptions.url = api.settle.supplierSettlement
      //   this.$refs['salesTemplate'].operationSuccess();
      // })
    },
    methods: {
      storeDefault() {
        if (this.$utils.getSysUser().storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'storeId')[0].disabled = true;
        }
      },
      getBrandSupplierChange(form) {
        form.supplierId = '';
        form.type = 10;
        this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = [];
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {
          storeId: form.storeId,
          type: form.type
        }).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      },
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/settlement/supplier/detail?id=' + row.id,
          query: {redirect: '/settlement/supplier'}
        }).catch(err => {
        });
      },
      toEditPage(row) {
        this.$router.push({path: '/settlement/supplier/add?id=' + row.id}).catch(err => {
        });
      },
      addRequisition() {
        this.$router.push({path: '/settlement/supplier/add'});
      },
      goodsDetailExport() {
        let selectData = this.$refs["salesTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["salesTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.wholesale.salesExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'WlWholesaleSalesExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/settle/supplier/SupplierSettlement.vue